/**
 *
 * @author Matthew Rawson @ 26/02/2018 15:24
 * @description
 * @notes
 */
import React, {Component, ReactNode} from "react"
import {get, isArray, isString, cloneDeep} from "lodash"

import {Http403} from "@irati/ui/src/Errors"

import {AuthContext} from "../history/routing/AuthContext"
import {AuthedCheckerContext, SetAuthStatus} from "../history/routing/AuthedChecker"
import id from "../id"

/**
 * Helper to determine if I have all required permissions
 *
 * @param permissions {array|string}
 * @param apps {object}
 * @returns {boolean}
 */
export const doIHavePermission = (permissions: string | string[], apps: any) => {
  let hasPermission = true
  let requestedPermissions = cloneDeep(permissions)
  if (requestedPermissions && isString(requestedPermissions)) requestedPermissions = [requestedPermissions]
  if (!isArray(requestedPermissions)) throw new Error("Provide a string or an array of strings as permissions")

  requestedPermissions.forEach((permission) => {
    hasPermission = !get(apps, permission) ? false : hasPermission
  })

  return hasPermission
}

interface Props {
  id?: string
  permissions: string | string[]
  Error: ReactNode
  unauthed: boolean
}

class HasPermissionTo extends Component<Props> {
  static contextType = AuthContext

  static defaultProps = {
    permissions: [],
    children: null,
    Error: <Http403 />,
    unauthed: false
  }

  render() {
    const idNamespace = id("HasPermissionTo", this.props)
    const {unauthed, children, Error} = this.props

    let apps = {}
    try {
      apps = this.context?.authed.get().productPermissions
    } catch (e) {
      /* no-op */
    }

    const hasPermission = doIHavePermission(this.props.permissions, apps)

    return (
      <AuthedCheckerContext.Consumer>
        {({setAuthed}) => (
          <div id={idNamespace}>
            <SetAuthStatus setAuthed={setAuthed} unauthed={unauthed} />
            {hasPermission && children}

            {!hasPermission && Error}
          </div>
        )}
      </AuthedCheckerContext.Consumer>
    )
  }
}

export default HasPermissionTo
